import { jsxs as i, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2359.js";
function t({ size: e = l }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { shapeRendering: "optimizeQuality", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M36.0003 29.8333C36.0003 29.5571 36.2242 29.3333 36.5003 29.3333H39.5003C39.7764 29.3333 40.0003 29.5571 40.0003 29.8333V39.4999C40.0003 39.7761 39.7764 39.9999 39.5003 39.9999H36.5003C36.2242 39.9999 36.0003 39.7761 36.0003 39.4999V29.8333Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M30.8447 32.0001C30.5686 32.0001 30.3447 32.224 30.3447 32.5001V39.5001C30.3447 39.7763 30.5686 40.0001 30.8447 40.0001H33.8447C34.1209 40.0001 34.3447 39.7763 34.3447 39.5001V32.5001C34.3447 32.224 34.1209 32.0001 33.8447 32.0001H30.8447Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M25.1919 34.6666C24.9158 34.6666 24.6919 34.8905 24.6919 35.1666V39.5C24.6919 39.7761 24.9158 40 25.1919 40H28.1919C28.468 40 28.6919 39.7761 28.6919 39.5V35.1666C28.6919 34.8905 28.468 34.6666 28.1919 34.6666H25.1919Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M28 17C32.14 17 35.7457 19.287 37.6229 22.6666H38.7526C36.789 18.7154 32.7116 16 28 16C21.3726 16 16 21.3726 16 28C16 32.7304 18.7371 36.8215 22.7139 38.776V37.649C19.3084 35.7793 17 32.1593 17 28C17 21.9249 21.9249 17 28 17Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M29.5169 22.634C29.1949 22.4925 28.8727 22.3916 28.5506 22.3318V20.8204H27.5939V22.2661C26.9493 22.3143 26.4315 22.5228 26.0508 22.8999C25.653 23.2937 25.4551 23.7913 25.4551 24.3848C25.4551 24.5828 25.48 24.7681 25.5306 24.9401C25.58 25.1079 25.6415 25.2567 25.7157 25.3856C25.7922 25.5184 25.9003 25.6423 26.0373 25.7579C26.1698 25.8696 26.2933 25.9626 26.4078 26.0361C26.5243 26.111 26.6794 26.1889 26.8708 26.27C27.0605 26.3504 27.2207 26.4143 27.3513 26.4616C27.4812 26.5087 27.6578 26.5681 27.8782 26.639C28.1192 26.7131 28.3123 26.7775 28.4581 26.8323C28.6023 26.8865 28.7507 26.9536 28.9032 27.0338C29.0532 27.1126 29.1631 27.1921 29.2374 27.2708C29.3127 27.3506 29.3763 27.4492 29.4274 27.5683C29.4764 27.6827 29.5018 27.8133 29.5018 27.9618C29.5018 28.2862 29.3811 28.5343 29.1397 28.7172C28.8935 28.9037 28.5681 29.0012 28.1547 29.0012C27.7955 29.0012 27.4301 28.9236 27.0579 28.7663C26.6872 28.6097 26.3523 28.3818 26.053 28.0817L25.9759 28.0043L25.2661 28.8674L25.3308 28.9309C25.9897 29.5776 26.7447 29.9587 27.5939 30.0697V31.4871H28.5506V30.0832C29.2067 30.0147 29.734 29.795 30.1234 29.4167C30.5311 29.0205 30.7334 28.5123 30.7334 27.9004C30.7334 27.6885 30.7097 27.491 30.6614 27.3087C30.6142 27.1303 30.5559 26.9734 30.4858 26.839C30.4132 26.6998 30.3068 26.5697 30.1695 26.448C30.0369 26.3305 29.9131 26.2335 29.7982 26.1577C29.6808 26.0802 29.5185 25.9993 29.3143 25.9145C29.1117 25.8304 28.941 25.7644 28.8027 25.717C28.6664 25.6703 28.4739 25.6061 28.2245 25.5242C28.0016 25.45 27.8258 25.3874 27.6962 25.3363C27.5677 25.2856 27.4258 25.2209 27.2703 25.142C27.1173 25.0643 27.0069 24.9896 26.9343 24.9192C26.8606 24.8478 26.7973 24.7603 26.7449 24.6558C26.6956 24.5572 26.6702 24.447 26.6702 24.3234C26.6702 24.0203 26.7798 23.7955 26.9957 23.6356C27.2176 23.4714 27.5184 23.3844 27.9073 23.3844C28.1797 23.3844 28.4848 23.4412 28.8236 23.5576C29.1606 23.6734 29.4656 23.8342 29.7393 24.0398L29.8154 24.0969L30.5165 23.2363L30.4371 23.1741C30.1731 22.9674 29.8661 22.7876 29.5169 22.634Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0295 40H28.1919C28.468 40 28.6919 39.7761 28.6919 39.5V35.1666C28.6919 34.8905 28.468 34.6666 28.1919 34.6666H25.1919C24.9158 34.6666 24.6919 34.8905 24.6919 35.1666V39.5C24.6919 39.7761 24.9158 40 25.1919 40H27.9705L28 40L28.0295 40ZM25.6919 39V35.6666H27.6919V39H25.6919Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.5005 29.3333C36.2243 29.3333 36.0005 29.5571 36.0005 29.8333V39.4999C36.0005 39.7761 36.2243 39.9999 36.5005 39.9999H39.5005C39.7766 39.9999 40.0005 39.7761 40.0005 39.4999V29.8333C40.0005 29.5571 39.7766 29.3333 39.5005 29.3333H36.5005ZM37.0005 30.3333V38.9999H39.0005V30.3333H37.0005Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.8447 32.0001C30.5686 32.0001 30.3447 32.224 30.3447 32.5001V39.5001C30.3447 39.7763 30.5686 40.0001 30.8447 40.0001H33.8447C34.1209 40.0001 34.3447 39.7763 34.3447 39.5001V32.5001C34.3447 32.224 34.1209 32.0001 33.8447 32.0001H30.8447ZM31.3447 33.0001V39.0001H33.3447V33.0001H31.3447Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricAttributeImpactIcon
};
//# sourceMappingURL=index.es381.js.map
